<template>
    <aside v-if="!auth.id">
        <router-link class="adEngine"
            :to="action">
            <img class="image"
                :src="constants.adEngine.register"
                alt="Astronaut walking on a moon"
                loading="lazy"/>
            <div class="content">
                <div class="text">
                    <Heading
                        :h="3"
                        size="s"
                        weight="regular"
                        v-html="heading">
                    </Heading>
                </div>
                <Button
                    appearance="cta"
                    suffixIcon="arrow_right_alt"
                    size="small">
                    {{ cta }}
                </Button>
            </div>
            <p class="adBy">{{ siteContent.adEngine.adBy }} <router-link to="/creator/universe">Universe</router-link></p>
        </router-link>
    </aside>
</template>

<script>
    export default {
        name: 'AdEngine',
        computed: {
            heading() {
                return this.siteContent.adEngine.register.text
            },
            cta() {
                return this.siteContent.adEngine.register.cta
            },
            action() {
                return '/auth'
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../scss/variables';

    .adEngine {
        display: flex;
        align-items: center;
        position: relative;
        width: 100%;
        height: 28rem;
        padding: 6rem;
        box-shadow: var(--shadow-l);
        border-radius: 1rem;
        transition: $transition-eio-20;
        margin: 4rem 0 2rem 0;
        overflow: hidden;

        &:hover {
            transform: translateY(-0.5rem) scale(1.01);
            box-shadow: var(--shadow-xl);
        }

        &:focus {
            outline: 0;
            box-shadow: var(--shadow-focus-s);
        }
    }

    .image {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
    }

    .content {
        display: flex;
        flex-direction: column;
        position: relative;
        z-index: 1;
        color: var(--color-white-important);
        width: 100%;
    }

    .h3 {
        margin: 0 0 2rem 0;
    }

    .adBy {
        position: absolute;
        left: 6rem;
        bottom: 2.5rem;
        margin: 0;
        font-size: 1rem;
        color: var(--color-grey-600);
    }

    @media all and (max-width: 1024px) {
        .adEngine {
            padding-left: 3rem;
            margin-top: 3rem;
        }

        .adBy {
            left: 3rem;
        }
    }

    @media all and (max-width: 640px) {
        .adEngine {
            flex-direction: column;
            align-items: center;
            justify-content: space-between;
            padding: 4rem 1.5rem;
            height: 36rem;
        }

        .content {
            align-items: center;
        }

        .text {
            text-align: center;
        }

        .adBy {
            position: relative;
            left: auto;
            bottom: auto;
        }

        .image {
            object-position: 100% 50%;
        }
    }

    @media all and (max-width: 480px) {
        .image {
            object-position: 80% 50%;
        }
    }
</style>